// Production patch: update collection + recommendations tile price when variant dropdown changes.
// Supports both legacy .variant-select and theme's .product-block__variant-select.
// Updates both price and compare-at price, and toggles reduced styling.

(function () {
  function formatMoney(cents) {
    try {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.money_format);
      }
    } catch (e) {}
    return (cents / 100).toFixed(2);
  }

  function updateBlockPrice(productBlock, variant) {
    if (!productBlock || !variant) return;

    const valueEl =
      productBlock.querySelector('.product-price__value') ||
      productBlock.querySelector('.product-price .theme-money') ||
      productBlock.querySelector('.product-price .theme_money');

    if (valueEl) {
      valueEl.textContent = formatMoney(variant.price);
      if (valueEl.classList) {
        valueEl.classList.toggle(
          'product-price__reduced',
          !!(variant.compare_at_price && variant.compare_at_price > variant.price)
        );
      }
    }

    const containerEl = productBlock.querySelector('.product-price');
    if (!containerEl) return;

    const shouldShowCompare =
      !!(variant.compare_at_price && variant.compare_at_price > variant.price);

    let compareEl = productBlock.querySelector('.product-price__compare');

    if (shouldShowCompare) {
      if (!compareEl) {
        compareEl = document.createElement('span');
        compareEl.className = 'product-price__compare theme-money';
        containerEl.appendChild(compareEl);
      }
      compareEl.textContent = formatMoney(variant.compare_at_price);
      compareEl.style.display = '';
    } else if (compareEl) {
      compareEl.style.display = 'none';
    }
  }

  document.addEventListener('change', function (e) {
    const target = e.target;
    if (!target || target.tagName !== 'SELECT') return;

    // Support both old and current class names
    if (
      !target.classList.contains('variant-select') &&
      !target.classList.contains('product-block__variant-select')
    ) {
      return;
    }

    const option = target.options[target.selectedIndex];
    const variantId = option && option.value;
    const productBlock = target.closest('.product-block');
    if (!productBlock || !variantId) return;

    const productLink = productBlock.querySelector("a[href*='/products/']");
    if (!productLink) return;

    const handle = productLink
      .getAttribute('href')
      .split('/products/')[1]
      .split('?')[0];

    fetch(`/products/${handle}.js`)
      .then((res) => res.json())
      .then((product) => {
        const variant = product.variants.find((v) => v.id == parseInt(variantId, 10));
        updateBlockPrice(productBlock, variant);
      })
      .catch(function () {});
  });
})();
